import EventActionProto from '../event-action-proto'

module.exports = class EventNoteTypeResetByCompany extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
        this.restartApps = ['organization-settings-task-types','organization-settings-task-type'];
    }

    validate() {
        return true;
    }

    process() {
        gd.session.noteTypes.resetAndMarkOldModelsAsDeleted(this.data.data, this.data.companyId)

        super.process();
    }
};

